<script>
    import { createEventDispatcher } from "svelte";
    import Calender from "./Calendar.svelte";
    import { getMonthName } from "./date-time";

    const dispatch = createEventDispatcher();

    // props
    export let isAllowed = () => true;
    export let selected = new Date();

    // state
    let date, month, year, showDatePicker;

    // so that these change with props
    $: {
        date = selected.getDate();
        month = selected.getMonth();
        year = selected.getFullYear();
    }

    // handlers
    const onFocus = () => {
        showDatePicker = true;
    };

    const next = () => {
        if (month === 11) {
            month = 0;
            year = year + 1;
            return;
        }
        month = month + 1;
    };

    const prev = () => {
        if (month === 0) {
            month = 11;
            year -= 1;
            return;
        }
        month -= 1;
    };

    const onDateChange = (d) => {
        showDatePicker = false;
        dispatch("datechange", d.detail);
    };
</script>

<div class="relative">
    <input
        class="ds-date-input"
        type="text"
        on:focus={onFocus}
        value={selected.toDateString()}
    />
    {#if showDatePicker}
        <div class="box">
            <div class="month-name">
                <div class="center">
                    <button on:click={prev}>Prev</button>
                </div>
                <div class="center">{getMonthName(month)} {year}</div>
                <div class="center">
                    <button on:click={next}>Next</button>
                </div>
            </div>
            <Calender
                {month}
                {year}
                date={selected}
                {isAllowed}
                on:datechange={onDateChange}
            />
        </div>
    {/if}
</div>

<style>
    .relative {
        position: relative;
        display: inline;
    }

    .ds-date-input {
        padding: 0.55rem 0.75rem;
        border: 1px solid var(--ds-border-3, #e5e7eb);
        border-radius: var(--ds-radius-sm, 6px);
        font-size: 0.9rem;
        font-family: inherit;
        color: var(--ds-text, #111827);
        background: var(--ds-surface, #fff);
        box-sizing: border-box;
        margin: 0;
        transition: border-color 0.15s, box-shadow 0.15s;
    }
    .ds-date-input:focus {
        outline: none;
        border-color: var(--ds-accent, #2563eb);
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
    }

    .box {
        z-index: 1000;
        position: absolute;
        top: 40px;
        left: 0px;
        display: inline-block;
        background: var(--ds-surface, #fff);
        border: 1px solid var(--ds-border, #eef0f3);
        border-radius: var(--ds-radius-md, 10px);
        box-shadow: var(--ds-shadow-pop, 0 8px 24px rgba(0, 0, 0, 0.08));
        padding: 10px 12px 12px;
    }

    .month-name {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 6px 0;
        font-weight: 600;
        color: var(--ds-text, #111827);
        font-size: 0.9rem;
    }

    .center {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .center :global(button) {
        background: none;
        border: none;
        color: var(--ds-accent, #2563eb);
        font-size: 0.85rem;
        font-weight: 600;
        font-family: inherit;
        cursor: pointer;
        padding: 0.3rem 0.5rem;
        border-radius: var(--ds-radius-sm, 6px);
        transition: background 0.15s;
    }

    .center :global(button:hover) {
        background: var(--ds-accent-soft, #dbeafe);
    }
</style>
